import { resolveCollectionUsername } from '../firebase/functions';

const pendingPromises = new Map<string, Promise<string | null>>();

const cacheKey = (
  collectionId: string,
  userId: string,
  membershipVersion: number,
): string => `${collectionId}:${userId}:${membershipVersion}`;

export const userProfileResolverService = {
  async resolveUsername(
    collectionId: string,
    userId: string,
    membershipVersion: number,
  ): Promise<string | null> {
    if (!collectionId || !userId || !Number.isSafeInteger(membershipVersion))
      return null;
    const key = cacheKey(collectionId, userId, membershipVersion);
    if (pendingPromises.has(key)) {
      return pendingPromises.get(key)!;
    }

    const promise = (async () => {
      try {
        const response = await resolveCollectionUsername({
          collectionId,
          targetUserId: userId,
          expectedMembershipVersion: membershipVersion,
        });
        return response.data.username || null;
      } catch {
        return null;
      }
    })();

    pendingPromises.set(key, promise);
    void promise.then(
      () => {
        if (pendingPromises.get(key) === promise) pendingPromises.delete(key);
      },
      () => {
        if (pendingPromises.get(key) === promise) pendingPromises.delete(key);
      },
    );
    return promise;
  },

  clearCache(): void {
    pendingPromises.clear();
  },
};
